import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding-top: ${props => props.theme.spacings.kilo};
`;

export const Separator = styled.div`
  padding-left: ${props => props.theme.spacings.bit};
`;

export const Content = styled.span`
  display: flex;
  max-width: 150px;
  width: 150px;
`;
